import { z } from 'zod';

export const LeadResponse = z.object({
  success: z.boolean(),
});
export type LeadResponse = z.infer<typeof LeadResponse>;

const locationBase = z.object({
  accountId: z.string().optional(),
  globalId: z.string().optional(),
  churchName: z.string(),
  churchAddress: z.string(),
  churchCity: z.string(),
  churchState: z.string(),
  churchPostal: z.string(),
  churchCountry: z.string().optional(),
  churchWebsite: z.string().optional(),
});

/** LEAD FORMS */
export const LeadContact = z.object({
  contactId: z.string().optional(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string().email(),
  phone: z.string().optional(),
  role: z.string().optional(),
  sourceCode: z.string().optional(),
  subscriptionCode: z.string().optional(),
});
export type LeadContact = z.infer<typeof LeadContact>;

export const LeadChurch = locationBase.extend({
  memberSize: z.string().optional(),
  sourceCode: z.string().optional(),
});
export type LeadChurch = z.infer<typeof LeadChurch>;

export interface LeadRequest {
  leadType: string;
  contact: LeadContact;
  church: LeadChurch;
}

/** EVENT FORMS */
export const LeadHost = LeadContact.extend({
  accountId: z.string().optional(),
  globalId: z.string().optional(),
  isPastor: z.boolean().optional(),
  withKids: z.boolean().optional(),
  shippingAddress: z.string().optional(),
  shippingCity: z.string().optional(),
  shippingState: z.string().optional(),
  shippingPostal: z.string().optional(),
  items: z.string().array().optional(),
  // deprecating in favor of Items
  tShirtSize: z.string().optional(),
  tShirtSizeKids: z.string().optional(),
  tShirtSizeCoHost: z.string().optional(),
});
export type LeadHost = z.infer<typeof LeadHost>;

export const LeadEvent = locationBase.extend({
  eventDate: z.string().optional(),
  audienceSize: z.string().optional(),
});
export type LeadEvent = z.infer<typeof LeadEvent>;

export interface EventLeadRequest {
  leadType: string;
  sourceCode: string;
  host: LeadHost;
  event?: LeadEvent;
}

/** COMPASSION SUNDAY FORMS */
export enum CompassionSundayType {
  Planning = 'planning',
  Registration = 'registration',
}

export type CSLeadHost = z.infer<typeof LeadHost>;
export type CSLeadEvent = z.infer<typeof LeadEvent>;
export interface CompassionSundayRequest {
  csType: CompassionSundayType;
  sourceCode: string;
  host: CSLeadHost;
  event?: CSLeadEvent;
}
